import { PaperContainer } from '@ui-components/containers/PaperContainer'
import { PropsWithChildren, ReactNode } from 'react'
import { styled } from 'styled-components'

import { PAGE_BOTTOM_PADDING } from '../global/constants'
import { Footer } from './Footer'

const BottomPadding = styled.div`
  padding-bottom: ${PAGE_BOTTOM_PADDING}px;
`

interface WideContainerProps extends PropsWithChildren {
  footerContent?: ReactNode
  fullWidthFooter?: boolean
  ['data-testid']?: string
}

export const WideContainer = (props: WideContainerProps) => {
  const { footerContent, children, fullWidthFooter } = props
  return (
    <BottomPadding>
      <PaperContainer data-testid={props['data-testid'] ?? 'entrance'} $fullWidthSupport={true}>
        {children}
      </PaperContainer>
      <Footer fullWidthFooter={fullWidthFooter}>{footerContent}</Footer>
    </BottomPadding>
  )
}
